import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

interface LockIconProps extends IconProps {
  open?: boolean
}

export function LockIcon({ className, size = 20, open, ...props }: LockIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 8V6C7.25 3.37665 9.37665 1.25 12 1.25C14.6234 1.25 16.75 3.37665 16.75 6V8H17C19.2091 8 21 9.79086 21 12V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V12C3 9.79086 4.79086 8 7 8H7.25ZM8.75 6C8.75 4.20507 10.2051 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6V8H8.75V6ZM13 14C13 14.2536 12.9056 14.4852 12.75 14.6615V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V14.6615C11.0944 14.4852 11 14.2536 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z"
        className={cn('transition-all', open ? 'fill-transparent' : 'fill-[currentColor]')}
      />
      <path
        d="M12.75 14.6615C12.9056 14.4852 13 14.2536 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.2536 11.0944 14.4852 11.25 14.6615V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V14.6615Z"
        fill="currentColor"
        className={cn('transition-all', open ? 'fill-[currentColor' : 'fill-transparent')}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 6C8.75 4.20507 10.2051 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6C15.25 6.41421 15.5858 6.75 16 6.75C16.4142 6.75 16.75 6.41421 16.75 6C16.75 3.37665 14.6234 1.25 12 1.25C9.37665 1.25 7.25 3.37665 7.25 6V8H7C4.79086 8 3 9.79086 3 12V18C3 20.2091 4.79086 22 7 22H17C19.2091 22 21 20.2091 21 18V12C21 9.79086 19.2091 8 17 8H8.75V6ZM4.5 12C4.5 10.6193 5.61929 9.5 7 9.5H17C18.3807 9.5 19.5 10.6193 19.5 12V18C19.5 19.3807 18.3807 20.5 17 20.5H7C5.61929 20.5 4.5 19.3807 4.5 18V12Z"
        fill="currentColor"
      />
    </svg>
  )
}
